<template>
  <div class="hpanel">
    <template v-if="type === 'result'">
      <div class="text-center" v-if="$user.isFreeTrial()">
        <router-link :to="{name: 'Register'}" class="btn btn-info m-t m-b"> Free Signup</router-link>
      </div>

      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12 col-md-12 col-lg-5">
            <template v-if="!$user.isFreeTrial()">
              Research results
            </template>
            <template v-else>
              Best Experts & Documents (Demo extract)
            </template>
            <span ref="help">
              <button class="btn btn-info btn-xs" @click="showShareResult = true" title="Share these results with an email address"><i class="fa fa-share-alt"></i> Share</button>
              <template v-if="searchState === 2">
                <button v-if="followedSearchId" class="btn btn-info btn-xs" @click="unFollowSearch(followedSearchId)"><i class="fas fa-star"></i> UnMonitor</button>
                <button v-else class="btn btn-outline btn-info btn-xs" @click="followSearch(query)" data-toggle="popover" :data-content="'Periodically replay this query. Go to My dashboard to manage'"><i class="far fa-star"></i> Monitor</button>
              </template>
            </span>
          </div>
          <div class="col-xs-12 col-md-12 col-lg-7 search-result-filters">
            <filters v-if="!overlay" :type="listType" :workflow-id="context.workflowId" :context="context" :isFollowedSearch="followedSearchId !== null"></filters>
          </div>
        </div>
        <too-many-result-notification-box v-model="overlay" :is-simple-search="true"></too-many-result-notification-box>
      </div>
      <div class="panel-body no-padding">

        <template v-if="searchState === 0">
          <div class="panel-body">
            <div class="text-center">
              <h2 class="m-b-xs">Search Empty</h2>
              <div class="m">
                <i class="pe-7s-search fa-5x"></i>
              </div>
              <p class="small">
                For found the best experts in the word, use the search engine
              </p>
              <button class="btn btn-info btn-sm" @click="makeSearch">Make search</button>
            </div>
          </div>
        </template>
        <template v-else-if="searchState === 1">
          <div class="panel-body">
            <div class="text-center">
              <h2 class="m-b-xs">Search in Progress ...</h2>
              <div class="m">
                <div class="progress full m-t-xs" style="margin: 40px 0">
                  <div class="progress-bar progress-bar-striped active progress-bar-info" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
                  </div>
                </div>
              </div>
              <p class="small">
                we are exploring many databases around the world, it may take some time
              </p>
              <button class="btn btn-info btn-sm" @click="cancelSearch">Click to stop search</button>
            </div>
          </div>
        </template>
        <template v-else-if="searchState === 2">
          <template v-if="items.length === 0">
            <div class="panel-body">
              <div class="text-center">
                <h2 class="m-b-xs">Whoops</h2>
                <div class="m">
                  <i class="fa fa-exclamation-triangle fa-5x"></i>
                </div>
                <div class="text-left" style="display: inline-block;margin-top: 15px">
                  <h5>No results, you may :</h5>
                  <ul style="list-style: inside;margin-top: 10px">
                    <li>Check your query spelling</li>
                    <li>Try a less specific query</li>
                    <li>Use the advanced search</li>
                    <li>Watch our <a href="https://www.youtube.com/watch?v=Piv0KET7rUA" class="text-info" target="_blank" >tutorial on 'Search tips'</a></li>
                    <li> <a href="" target="_blank" class="text-info" >Contact us</a> for help</li>

                  </ul>
                </div>
                <div class="text-center" style="display: block;margin-top: 15px" >
                  <button class="btn btn-info btn-sm" @click="makeSearch">Refine search</button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="overlay text-center expert-overlay" v-if="overlay">
              <div style="margin: 150px 0">
              </div>
            </div>
            <simple-list-authors v-if="listType === 'author' || listType === 'patents'" ref="listAuthors"
                                 :allAuthors="items"
                                 :nbEstimateExperts="nbEstimateItems"
                                 :searchState="searchState" :listType="listType" :searchType="searchType"
                                 :searchCountries="searchCountries"
                                 :nbSearchCompanies="nbSearchCompanies"
                                 @updatePubDate="updatePubDate" @updateCountries="updateCountries"
                                 @updateItem="updateItem"
                                 :style="{minHeight: documentsHeight}"
                                 :context="context"
                                 :type="'result'"
                                 :localExperts="localExperts"
                                 :followedSearches="followedSearches">

            </simple-list-authors>
          </template>

        </template>
      </div>
    </template>
    <template v-if="showShareResult === true">
      <share-search-result v-model="showShareResult"></share-search-result>
    </template>
  </div>

</template>

<style>
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 500;
    width: 100%;
    height: 100%;
    display: block;
    background: #f8f9fb;
    opacity: 0.8;
  }

  .br-theme-bars-horizontal .br-widget {
    height: auto !important;
    margin: auto !important;
  }

  .br-theme-bars-horizontal .br-widget a, .br-theme-bars-horizontal .br-widget {
    width: 25px !important;
  }

</style>
<script>

import ListDocuments from '../ListDocuments/ListDocuments'
import ListAffiliations from '../ListAffiliations/ListAffiliations'
import SimpleListAuthors from '../ListAuthors/SimpleListAuthors'
import ListCompanies from '../ListCompanies/ListCompanies'
import Filters from '../filter/Filters'
import TooManyResultNotificationBox from '../search/TooManyResultNotificationBox'
import ShareSearchResult from '../modal/ShareSearchResult'
import {cleanQueryFromTagsinputToSearch} from '../../assets/scripts/search'
import FollowSearch from '../Mixins/FollowSearch'

export default {
  mixins: [FollowSearch],
  components: {
    ShareSearchResult,
    Filters,
    ListCompanies,
    SimpleListAuthors,
    ListAffiliations,
    ListDocuments,
    TooManyResultNotificationBox
  },
  props: ['listType', 'items', 'searchCountries', 'type', 'nbSearchCompanies', 'nbResults', 'totalNbResults',
    'searchType', 'searchState', 'query', 'showLimitPlan', 'followedSearches', 'localExperts'],
  name: 'ListSimple',
  data () {
    return {
      documentsHeight: 'auto',
      overlay: false,
      nbEstimateItems: 0,
      followedSearchId: null,
      context: {
        workflowId: 2,
        name: null,
        affiliationsFilter: [],
        affiliationsSelected: [],
        countriesFilter: [],
        countriesSelected: [],
        pubDateFilter: [],
        pubDateSelected: [],
        categoryFilter: [],
        categorySelected: [],
        expertSourceFilter: [],
        expertSourceSelected: [],
        publicationFilter: [],
        publicationsSelected: [],
        affiliationTypeFilter: [],
        affiliationTypeSelected: [],
        dateIncorporateFilter: [],
        dateIncorporateSelected: [],
        followedSearchFilter: [],
        newDocumentsSelected: [],
        newDocumentsFilter: [],
        filterSelected: null,
        nbItemsDisplay: this.$user.isFreeTrial() ? 10 : 25,
        changeSort: this.changeSort,
        displayMore: this.displayMore,
        displayAll: this.displayAll,
        addDocumentToBiblio: this.addDocumentToBiblio,
        citeDocument: this.citeDocument,
        shareDocument: this.shareDocument,
        addAuthor: this.addItem,
        removeAuthor: this.removeItem,
        addAuthorSimilar: this.addItemSimilar,
        searchAuthorByName: this.searchByName,
        addCompany: this.addItem,
        removeCompany: this.removeItem,
        addCompanySimilar: this.addItemSimilar,
        followSearch: this.followSearch,
        unFollowSearch: this.unFollowSearch,
        editAuthor: this.editAuthor,
        showLimitPlan: this.showLimitPlan
      },
      showShareResult: false
    }
  },
  watch: {
    'context.countriesFilter': function (countriesFilter) {
      if (typeof this.searchCountries !== 'undefined' && this.searchCountries.length !== 0) {
        this.searchCountries.forEach((searchCountry) => {
          let country = countriesFilter.find((country) => {
            return country.name === searchCountry
          })
          if (typeof country !== 'undefined') {
            this.context.countriesSelected.push(country)
          }
        })
      }
    },
    searchState: function (val) {
      if (val === 2) {
        if (this.items.length !== 0 && this.items.length !== 0 && this.totalNbResults !== 0) {
          this.context.affiliationsFilter = []
          this.context.countriesFilter = []
          this.context.pubDateFilter = []
          this.context.categoryFilter = []
          this.context.expertSourceFilter = []
          this.context.publicationFilter = []
          this.context.affiliationTypeFilter = []
          this.context.dateIncorporateFilter = []

          this.context.affiliationsSelected = []
          this.context.countriesSelected = []
          this.context.pubDateSelected = []
          this.context.categorySelected = []
          this.context.expertSourceSelected = []
          this.context.publicationsSelected = []
          this.context.affiliationTypeSelected = []
          this.context.dateIncorporateSelected = []
          this.context.nbItemsDisplay = this.$user.isFreeTrial() ? 10 : 25

          this.estimateItems()

          setTimeout(() => {
            if (typeof this.$refs.help !== 'undefined') {
              $(this.$refs.help).find('[data-toggle="popover"]').popover({
                trigger: 'hover',
                placement: 'top'
              })
            }
          })

          setTimeout(() => {
            this.$eventHub.$emit('tourCanStart', true)
          }, 1000)
          setTimeout(() => { this.getAffiliations() }, 7000)
        }
        // if (this.searchResult.suggestions.length !== 0) {
        //   this.documentsHeight = this.suggestionHeight + 120 + 'px'
        // }
      }
    },
    followedSearches: function (followedSearches) {
      let query = cleanQueryFromTagsinputToSearch(this.query).toLowerCase()
      let followedSearchId = null

      followedSearches.forEach((search) => {
        if (search.search_terms.term === query) {
          followedSearchId = search.id
        }
      })
      this.followedSearchId = followedSearchId
    }
  },
  methods: {
    estimateItems: function () {
      if (this.totalNbResults && this.items.length > this.nbResults) {
        let factor = this.items.length / this.nbResults

        this.nbEstimateItems = Math.round(factor * this.totalNbResults)

        this.overlay = (this.nbEstimateItems >= 60000)
      } else {
        this.nbEstimateItems = this.items.length
      }
      return this.nbEstimateItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },
    getAffiliations: function () {
      if (this.listType === 'author' && this.overlay === false) {
        this.$notify({
          title: 'Searching experts affiliations',
          icon: 'fa fa-refresh pe-spin pe-7s',
          duration: 20000,
          placement: 'bottom-right'
        })

        let authorsSearchAffiliation = []

        this.$refs.listAuthors.authors.forEach((author, index) => {
          if (index >= this.context.nbItemsDisplay) {
            return false
          } else if (author.affiliationSearched !== true && author.display === true) {
            author.affiliationSearched = true
            if (typeof author.expertSource === 'undefined' || (author.expertSource !== 'TECHNICAL EDISON' &&
              author.expertSource !== 'BICWORLD')) {
              authorsSearchAffiliation.push(author)
            }
          }
        })

        if (authorsSearchAffiliation.length !== 0) {
          authorsSearchAffiliation.forEach((author, index) => {
            let modulo = index % this.$proxies.length

            let domain = this.$proxies[modulo]

            this.$requestStack.add('get', domain + '/harvest/authors/' + author.authorID + '/affiliations/', null, 3)
              .then((response) => {
                author.affiliation = response.data
              })
              .catch((error) => {
              }).finally(() => {
                if (index % 10 === 0 || typeof authorsSearchAffiliation[index + 1] === 'undefined') {
                  setTimeout(() => {
                    if (typeof this.$refs.listAuthors !== 'undefined') {
                      this.$refs.listAuthors.initAuthors()
                    }
                  }, 5000)
                }
              })
          })
        }
      }
    },
    updatePubDate: function (val) {
      this.$emit('updatePubDate', val)
    },
    updateCountries: function (val) {
      this.$emit('updateCountries', val)
    },
    addDocumentToBiblio: function (document) {
      this.showLimitPlan('saveDocument')
    },
    getDataForQueryAddAuthor: function (author, withSimilar = false, type) {
      let data = []
      data.push({
        author_id: author.authorID,
        documents: author.docs.map((document) => {
          return document.documentID
        }),
        score: author.score,
        search_terms: this.query,
        is_suggested: false,
        external_expert_suggestion_id: null,
        type: type // company or author
      })

      if (author.similar_authors.length !== 0) {
        let similarCompanyAuthors = []
        this.items.forEach((tmpAuthor) => {
          author.similar_authors.forEach((tmpAuthorId) => {
            if (tmpAuthor.authorID === tmpAuthorId) {
              similarCompanyAuthors.push(tmpAuthor)
            }
          })
        })

        if (similarCompanyAuthors.length !== 0) {
          similarCompanyAuthors.forEach((similarAuthor) => {
            data.push({
              author_id: similarAuthor.authorID,
              documents: similarAuthor.docs.map((document) => {
                return document.documentID
              }),
              score: similarAuthor.score,
              search_terms: this.query,
              is_suggested: !withSimilar,
              external_expert_suggestion_id: author.authorID,
              type: type // company or author
            })
          })
        }
      }
      return data
    },
    addItem: function (author, type) {
      this.showLimitPlan('addExpert')
    },
    updateItem: function (author) {
      let localAuthor = this.items.find((localAuthor) => {
        return localAuthor.authorID === author.authorID
      })

      if (typeof localAuthor !== 'undefined') {
        localAuthor.affiliationSearched = author.affiliationSearched

        if (typeof author.affiliation !== 'undefined') {
          localAuthor.affiliation = author.affiliation
          // this.initAuthors()
        }
      }
    },
    displayMore: function (e) {
      e.preventDefault()
      this.context.nbItemsDisplay += 10
      setTimeout(() => { this.getAffiliations() }, 3000)
    },
    displayAll: function (e) {
      e.preventDefault()

      this.$notify({
        type: 'warning',
        title: 'Display all',
        content: 'Can be slow with a lot of experts and take a lot of resources',
        placement: 'bottom-right'
      })
      this.context.nbItemsDisplay = this.items.length
      setTimeout(() => { this.getAffiliations() }, 7000)
    },
    makeSearch: function (e) {
      e.preventDefault()
      window.scrollTo(0, 0)
    },
    cancelSearch: function (e) {
      e.preventDefault()
      this.$eventHub.$emit('cancelSearch', true)
    },
    searchByName: function (author) {
      this.$eventHub.$emit('searchByName', author)
    },
    followSearch: function (query) {
      this.mixinFollowSearch(query, this.listType, null)
    },
    unFollowSearch: function (followSearchId) {
      this.mixinUnFollowSearch(followSearchId)
    }
  },
  beforeMount () {
    this.context.workflowId = 2
    this.context.name = 'expertResult'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListIdexlab/ListSimple.vue